import { css } from "@compiled/react";

const tabStyle = css({
    backgroundColor: "#F0F1F2",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    display: "flex",
    textAlign: "center",
    textDecoration: "none",
    height: 56,
    borderRadius: 28,
    paddingInlineEnd: 20,
    paddingInlineStart: 20,
    cursor: "pointer",
    border: "2px solid #F0F1F2",
    fontWeight: 500,
    fontSize: "1.25rem",
    fontFamily: "var(--bxp-charlie-display-font-family)",
    [":hover"]: {
        border: "2px solid #0C66E4",
        backgroundColor: "#E9F2FE"
    }
});

const selectedTabStyle = css({
    border: "2px solid #0C66E4",
    color: "#0C66E4"
});

export type IconTabsProps = {
    isSelected?: boolean;
    title: string;
};

export const RoundTab = ({ isSelected, title }: IconTabsProps) => {
    return <div css={[tabStyle, isSelected && selectedTabStyle]}>{title}</div>;
};
